<template>
  <div>
    <section>
      <h3 class="text-center" style="margin-bottom: 0">You Ordered</h3>
    </section>

    <!-- For users who bought a single a2 standard -->
    <div v-if="originally_ordered_one_standard_only">
      <ArsenalProduct
        arsenal_model="Standard"
        :show_arsenal_model="!hide_pro"
        :arsenal="order.products.arsenal"
        :prices="order.product_prices ? order.product_prices.arsenal_2_standard : prices.arsenal_2_standard"
        limit="1"
        disable_cable_select="true"
        show_upgrade_button="true"
        :upgraded_to_pro="upgraded_to_pro"
        :downgrade_to_standard="downgrade_to_standard"
      >
        <ul>
          <li>3x faster than Arsenal 1</li>
        </ul>
      </ArsenalProduct>

      <section v-if="!hide_pro_upgrade" class="special-offer">
        <h3 class="header">Special Offer</h3>
        <div class="content">
          <p class="line1">Upgrade to Arsenal 2 Pro for <strong>30% Off</strong></p>
          <p class="most-popular">
            <img :src="require(`app/assets/images/fire.png`)"/>
            MOST POPULAR
            <img :src="require(`app/assets/images/fire.png`)"/>
          </p>
          <ul class="features">
            <li>5x faster than Arsenal 1</li>
            <li>Weather Resistant design</li>
            <li>USB-C Ports</li>
          </ul>

          <hr />

          <ArsenalProduct
            arsenal_model="Pro"
            :show_arsenal_model=true
            :arsenal="order.products.arsenal_pro"
            :prices="order.product_prices ? order.product_prices.arsenal_2_pro : prices.arsenal_2_pro"
            limit="1"
            :discount_label="'30% OFF'"
            disable_cable_select="true"
            show_upgrade_button="true"
            :upgrade_price="prices.arsenal_2_pro.sale - arsenal_2_standard_original_price"
            :upgraded_to_pro="upgraded_to_pro"
            :upgrade_to_pro="upgrade_to_pro"
            :downgrade_to_standard="downgrade_to_standard"
          >
            <template v-slot:upgrade-modal-content>
              <h3 class="text-center">Upgrade Pricing</h3>
              <p style="text-align:right">You pre-ordered Arsenal 2 Standard for {{ format_currency(arsenal_2_standard_original_price) }}</p>
              <p style="text-align:right">Arsenal 2 Pro Price: {{ format_currency(prices.arsenal_2_pro.sale) }}</p>
              <p style="text-align:right; border-top: 1px solid #c7c7cd; padding-top:1em">
                Upgrade to Arsenal 2 Pro cost: {{ format_currency(prices.arsenal_2_pro.sale - arsenal_2_standard_original_price) }}
              </p>
            </template>
          </ArsenalProduct>
        </div>
      </section>
    </div>

    <!-- For users who bought a single a2 pro -->
    <div v-if="originally_ordered_one_pro_only">
      <ArsenalProduct
        arsenal_model="Pro"
        :show_arsenal_model="true"
        :arsenal="order.products.arsenal_pro"
        :prices="prices.arsenal_2_pro"
        limit="1"
        disable_cable_select="true"
      >
        <ul>
          <li>5x faster than Arsenal 1</li>
        </ul>
    </ArsenalProduct>
    </div>

    <div v-if="originally_ordered_one_arsenal_only">
      <section>
        <div class="product">
          <div class="cables">
            <h4 style="margin-top: 0">Choose Your Cable</h4>
            <Cables :arsenal_version="2" :arsenal="arsenal_product" :$v="arsenal_product_validations" />
          </div>
        </div>
      </section>
    </div>

    <!-- For users who bought more than one arsenal -->
    <div v-if="ordered_pro && !originally_ordered_one_arsenal_only">
        <ArsenalProduct
          arsenal_model="Pro"
          :show_arsenal_model="true"
          :arsenal="order.products.arsenal_pro"
          :$v="$v.order.products.arsenal_pro"
          :prices="prices.arsenal_2_pro"
          :min_limit="order.products.arsenal_pro.quantity"
        >
          <ul>
            <li>5x faster than Arsenal 1</li>
          </ul>
      </ArsenalProduct>
    </div>
    <div v-if="ordered_standard && !originally_ordered_one_arsenal_only">
      <ArsenalProduct
          arsenal_model="Standard"
          :show_arsenal_model="!hide_pro"
          :arsenal="order.products.arsenal"
          :$v="$v.order.products.arsenal"
          :prices="prices.arsenal_2_standard"
          :min_limit="order.products.arsenal.quantity"
        >
          <ul>
            <li>3x faster than Arsenal 1</li>
          </ul>
      </ArsenalProduct>
    </div>


    <Accessories subheader="Now, choose your accessories" :order="order" :prices="prices" :$v="$v" :prevent_refunds="true" :continental_usa="continental_usa" />
  </div>
</template>

<script>
import Accessories from "app/components/orders/Accessories";
import ArsenalProduct from "app/components/orders/ArsenalProduct";
import Cables from "app/components/orders/Cables";
import { format_currency } from 'app/helpers/CurrencyHelpers';
import _ from 'lodash';

export default {
  props: ["order", "prices", "$v", "hide_pro", "hide_pro_upgrade", "continental_usa"],
  data() {
    return {
      upgraded_to_pro: false,
      originally_ordered_one_standard_only: false,
      originally_ordered_one_pro_only: false,
      originally_ordered_one_arsenal_only: false
    };
  },
  mounted() {
    if (this.order.products.arsenal.quantity == 1 && this.order.products.arsenal_pro.quantity == 0) {
      this.originally_ordered_one_standard_only = true
      this.originally_ordered_one_arsenal_only = true
    }

    if (this.order.products.arsenal_pro.quantity == 1 && this.order.products.arsenal.quantity == 0) {
      this.originally_ordered_one_pro_only = true
      this.originally_ordered_one_arsenal_only = true
    }
  },
  computed: {
    pledge() {
      return this.order.products.pledge
    },
    arsenal_2_standard_original_price() {
      const lineItem = _.find(this.order.line_items, { description: 'Arsenal 2 Standard' })
      if (lineItem) {
        return lineItem.price / lineItem.quantity
      } else {
        return this.prices.arsenal_2_standard.sale
      }
    },
    ordered_standard() {
      return this.order.products.arsenal.quantity > 0
    },
    ordered_pro() {
      return this.order.products.arsenal_pro.quantity > 0
    },
    arsenal_product() {
      return this.order.products.arsenal.quantity > 0 ? this.order.products.arsenal : this.order.products.arsenal_pro
    },
    arsenal_product_validations() {
      return this.order.products.arsenal.quantity > 0 ? this.$v.order.products.arsenal : this.$v.order.products.arsenal_pro
    }
  },
  methods: {
    format_currency,
    // only allowed when customer has a single arsenal 2
    upgrade_to_pro() {
      this.upgraded_to_pro = true
      this.order.products.arsenal_pro.quantity += 1
      this.order.products.arsenal.quantity -= 1
      this.order.products.arsenal_pro.cables = this.order.products.arsenal.cables
      this.order.products.arsenal.cables = []
    },
    // only allowed when customer has a single arsenal 2
    downgrade_to_standard() {
      this.upgraded_to_pro = false
      this.order.products.arsenal.quantity += 1
      this.order.products.arsenal_pro.quantity -= 1
      this.order.products.arsenal.cables = this.order.products.arsenal_pro.cables
      this.order.products.arsenal_pro.cables = []
    },
  },
  components: { ArsenalProduct, Cables, Accessories },
};
</script>
